import { _ as N, f as I, o as lt, q as _e, i as D, p as ke, O as j, d as Lt, e as Tt, H as zt, t as ge, w as Dt, z as Ct, j as Qe } from "./index-CjjiqU7h.mjs";
import { R as ot } from "./index-BgcNEpwc.mjs";
import * as i from "react";
import { useRef as y, useEffect as Ht, useState as Ie } from "react";
import { r as et } from "./index-Omb0Wmns.mjs";
var ut = /* @__PURE__ */ i.forwardRef(function(e, s) {
  var n = e.height, f = e.offsetY, v = e.offsetX, d = e.children, c = e.prefixCls, u = e.onInnerResize, M = e.innerProps, h = e.rtl, R = e.extra, r = {}, g = {
    display: "flex",
    flexDirection: "column"
  };
  return f !== void 0 && (r = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, g = N(N({}, g), {}, I(I(I(I(I({
    transform: "translateY(".concat(f, "px)")
  }, h ? "marginRight" : "marginLeft", -v), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ i.createElement("div", {
    style: r
  }, /* @__PURE__ */ i.createElement(ot, {
    onResize: function(m) {
      var o = m.offsetHeight;
      o && u && u();
    }
  }, /* @__PURE__ */ i.createElement("div", lt({
    style: g,
    className: _e(I({}, "".concat(c, "-holder-inner"), c)),
    ref: s
  }, M), d, R)));
});
ut.displayName = "Filler";
function Pt(e) {
  var s = e.children, n = e.setRef, f = i.useCallback(function(v) {
    n(v);
  }, []);
  return /* @__PURE__ */ i.cloneElement(s, {
    ref: f
  });
}
function Ot(e, s, n, f, v, d, c, u) {
  var M = u.getKey;
  return e.slice(s, n + 1).map(function(h, R) {
    var r = s + R, g = c(h, r, {
      style: {
        width: f
      },
      offsetX: v
    }), l = M(h);
    return /* @__PURE__ */ i.createElement(Pt, {
      key: l,
      setRef: function(o) {
        return d(h, o);
      }
    }, g);
  });
}
function It(e, s, n) {
  var f = e.length, v = s.length, d, c;
  if (f === 0 && v === 0)
    return null;
  f < v ? (d = e, c = s) : (d = s, c = e);
  var u = {
    __EMPTY_ITEM__: !0
  };
  function M(m) {
    return m !== void 0 ? n(m) : u;
  }
  for (var h = null, R = Math.abs(f - v) !== 1, r = 0; r < c.length; r += 1) {
    var g = M(d[r]), l = M(c[r]);
    if (g !== l) {
      h = r, R = R || g !== M(c[r + 1]);
      break;
    }
  }
  return h === null ? null : {
    index: h,
    multiple: R
  };
}
function Nt(e, s, n) {
  var f = i.useState(e), v = D(f, 2), d = v[0], c = v[1], u = i.useState(null), M = D(u, 2), h = M[0], R = M[1];
  return i.useEffect(function() {
    var r = It(d || [], e || [], s);
    (r == null ? void 0 : r.index) !== void 0 && (n == null || n(r.index), R(e[r.index])), c(e);
  }, [e]), [h];
}
var tt = (typeof navigator > "u" ? "undefined" : ke(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const ct = function(e, s, n, f) {
  var v = y(!1), d = y(null);
  function c() {
    clearTimeout(d.current), v.current = !0, d.current = setTimeout(function() {
      v.current = !1;
    }, 50);
  }
  var u = y({
    top: e,
    bottom: s,
    left: n,
    right: f
  });
  return u.current.top = e, u.current.bottom = s, u.current.left = n, u.current.right = f, function(M, h) {
    var R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = M ? (
      // Pass origin wheel when on the left
      h < 0 && u.current.left || // Pass origin wheel when on the right
      h > 0 && u.current.right
    ) : h < 0 && u.current.top || // Pass origin wheel when on the bottom
    h > 0 && u.current.bottom;
    return R && r ? (clearTimeout(d.current), v.current = !1) : (!r || v.current) && c(), !v.current && r;
  };
};
function kt(e, s, n, f, v, d, c) {
  var u = y(0), M = y(null), h = y(null), R = y(!1), r = ct(s, n, f, v);
  function g(S, E) {
    j.cancel(M.current), u.current += E, h.current = E, !r(!1, E) && (tt || S.preventDefault(), M.current = j(function() {
      var T = R.current ? 10 : 1;
      c(u.current * T), u.current = 0;
    }));
  }
  function l(S, E) {
    c(E, !0), tt || S.preventDefault();
  }
  var m = y(null), o = y(null);
  function p(S) {
    if (e) {
      j.cancel(o.current), o.current = j(function() {
        m.current = null;
      }, 2);
      var E = S.deltaX, T = S.deltaY, U = S.shiftKey, Y = E, x = T;
      (m.current === "sx" || !m.current && U && T && !E) && (Y = T, x = 0, m.current = "sx");
      var V = Math.abs(Y), k = Math.abs(x);
      m.current === null && (m.current = d && V > k ? "x" : "y"), m.current === "y" ? g(S, x) : l(S, Y);
    }
  }
  function _(S) {
    e && (R.current = S.detail === h.current);
  }
  return [p, _];
}
function $t(e, s, n, f) {
  var v = i.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, n.id, f]), d = D(v, 2), c = d[0], u = d[1], M = function(R) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : R, g = c.get(R), l = c.get(r);
    if (g === void 0 || l === void 0)
      for (var m = e.length, o = u.length; o < m; o += 1) {
        var p, _ = e[o], S = s(_);
        c.set(S, o);
        var E = (p = n.get(S)) !== null && p !== void 0 ? p : f;
        if (u[o] = (u[o - 1] || 0) + E, S === R && (g = o), S === r && (l = o), g !== void 0 && l !== void 0)
          break;
      }
    return {
      top: u[g - 1] || 0,
      bottom: u[l]
    };
  };
  return M;
}
var Yt = /* @__PURE__ */ function() {
  function e() {
    Tt(this, e), I(this, "maps", void 0), I(this, "id", 0), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return Lt(e, [{
    key: "set",
    value: function(n, f) {
      this.maps[n] = f, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
  }]), e;
}();
function Ft(e, s, n) {
  var f = i.useState(0), v = D(f, 2), d = v[0], c = v[1], u = y(/* @__PURE__ */ new Map()), M = y(new Yt()), h = y();
  function R() {
    j.cancel(h.current);
  }
  function r() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    R();
    var m = function() {
      u.current.forEach(function(p, _) {
        if (p && p.offsetParent) {
          var S = zt(p), E = S.offsetHeight;
          M.current.get(_) !== E && M.current.set(_, S.offsetHeight);
        }
      }), c(function(p) {
        return p + 1;
      });
    };
    l ? m() : h.current = j(m);
  }
  function g(l, m) {
    var o = e(l), p = u.current.get(o);
    m ? (u.current.set(o, m), r()) : u.current.delete(o), !p != !m && (m ? s == null || s(l) : n == null || n(l));
  }
  return Ht(function() {
    return R;
  }, []), [g, r, M.current, d];
}
var rt = 14 / 15;
function Xt(e, s, n) {
  var f = y(!1), v = y(0), d = y(0), c = y(null), u = y(null), M, h = function(l) {
    if (f.current) {
      var m = Math.ceil(l.touches[0].pageX), o = Math.ceil(l.touches[0].pageY), p = v.current - m, _ = d.current - o, S = Math.abs(p) > Math.abs(_);
      S ? v.current = m : d.current = o, n(S, S ? p : _) && l.preventDefault(), clearInterval(u.current), u.current = setInterval(function() {
        S ? p *= rt : _ *= rt;
        var E = Math.floor(S ? p : _);
        (!n(S, E, !0) || Math.abs(E) <= 0.1) && clearInterval(u.current);
      }, 16);
    }
  }, R = function() {
    f.current = !1, M();
  }, r = function(l) {
    M(), l.touches.length === 1 && !f.current && (f.current = !0, v.current = Math.ceil(l.touches[0].pageX), d.current = Math.ceil(l.touches[0].pageY), c.current = l.target, c.current.addEventListener("touchmove", h), c.current.addEventListener("touchend", R));
  };
  M = function() {
    c.current && (c.current.removeEventListener("touchmove", h), c.current.removeEventListener("touchend", R));
  }, ge(function() {
    return e && s.current.addEventListener("touchstart", r), function() {
      var g;
      (g = s.current) === null || g === void 0 || g.removeEventListener("touchstart", r), M(), clearInterval(u.current);
    };
  }, [e]);
}
var nt = 10;
function Vt(e, s, n, f, v, d, c, u) {
  var M = i.useRef(), h = i.useState(null), R = D(h, 2), r = R[0], g = R[1];
  return ge(function() {
    if (r && r.times < nt) {
      if (!e.current) {
        g(function(C) {
          return N({}, C);
        });
        return;
      }
      d();
      var l = r.targetAlign, m = r.originAlign, o = r.index, p = r.offset, _ = e.current.clientHeight, S = !1, E = l, T = null;
      if (_) {
        for (var U = l || m, Y = 0, x = 0, V = 0, k = Math.min(s.length - 1, o), K = 0; K <= k; K += 1) {
          var A = v(s[K]);
          x = Y;
          var J = n.get(A);
          V = x + (J === void 0 ? f : J), Y = V;
        }
        for (var Q = U === "top" ? p : _ - p, $ = k; $ >= 0; $ -= 1) {
          var ne = v(s[$]), P = n.get(ne);
          if (P === void 0) {
            S = !0;
            break;
          }
          if (Q -= P, Q <= 0)
            break;
        }
        switch (U) {
          case "top":
            T = x - p;
            break;
          case "bottom":
            T = V - _ + p;
            break;
          default: {
            var ee = e.current.scrollTop, W = ee + _;
            x < ee ? E = "top" : V > W && (E = "bottom");
          }
        }
        T !== null && c(T), T !== r.lastTop && (S = !0);
      }
      S && g(N(N({}, r), {}, {
        times: r.times + 1,
        targetAlign: E,
        lastTop: T
      }));
    } else
      process.env.NODE_ENV !== "production" && (r == null ? void 0 : r.times) === nt && Dt(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [r, e.current]), function(l) {
    if (l == null) {
      u();
      return;
    }
    if (j.cancel(M.current), typeof l == "number")
      c(l);
    else if (l && ke(l) === "object") {
      var m, o = l.align;
      "index" in l ? m = l.index : m = s.findIndex(function(S) {
        return v(S) === l.key;
      });
      var p = l.offset, _ = p === void 0 ? 0 : p;
      g({
        times: 0,
        index: m,
        offset: _,
        originAlign: o
      });
    }
  };
}
function at(e, s) {
  var n = "touches" in e ? e.touches[0] : e;
  return n[s ? "pageX" : "pageY"];
}
var Ne = /* @__PURE__ */ i.forwardRef(function(e, s) {
  var n = e.prefixCls, f = e.rtl, v = e.scrollOffset, d = e.scrollRange, c = e.onStartMove, u = e.onStopMove, M = e.onScroll, h = e.horizontal, R = e.spinSize, r = e.containerSize, g = e.style, l = e.thumbStyle, m = i.useState(!1), o = D(m, 2), p = o[0], _ = o[1], S = i.useState(null), E = D(S, 2), T = E[0], U = E[1], Y = i.useState(null), x = D(Y, 2), V = x[0], k = x[1], K = !f, A = i.useRef(), J = i.useRef(), Q = i.useState(!1), $ = D(Q, 2), ne = $[0], P = $[1], ee = i.useRef(), W = function() {
    clearTimeout(ee.current), P(!0), ee.current = setTimeout(function() {
      P(!1);
    }, 3e3);
  }, C = d - r || 0, ue = r - R || 0, L = i.useMemo(function() {
    if (v === 0 || C === 0)
      return 0;
    var O = v / C;
    return O * ue;
  }, [v, C, ue]), te = function(w) {
    w.stopPropagation(), w.preventDefault();
  }, ae = i.useRef({
    top: L,
    dragging: p,
    pageY: T,
    startTop: V
  });
  ae.current = {
    top: L,
    dragging: p,
    pageY: T,
    startTop: V
  };
  var ie = function(w) {
    _(!0), U(at(w, h)), k(ae.current.top), c(), w.stopPropagation(), w.preventDefault();
  };
  i.useEffect(function() {
    var O = function(le) {
      le.preventDefault();
    }, w = A.current, X = J.current;
    return w.addEventListener("touchstart", O), X.addEventListener("touchstart", ie), function() {
      w.removeEventListener("touchstart", O), X.removeEventListener("touchstart", ie);
    };
  }, []);
  var me = i.useRef();
  me.current = C;
  var ce = i.useRef();
  ce.current = ue, i.useEffect(function() {
    if (p) {
      var O, w = function(le) {
        var se = ae.current, pe = se.dragging, Me = se.pageY, be = se.startTop;
        if (j.cancel(O), pe) {
          var ye = at(le, h) - Me, q = be;
          !K && h ? q -= ye : q += ye;
          var fe = me.current, Ee = ce.current, Le = Ee ? q / Ee : 0, re = Math.ceil(Le * fe);
          re = Math.max(re, 0), re = Math.min(re, fe), O = j(function() {
            M(re, h);
          });
        }
      }, X = function() {
        _(!1), u();
      };
      return window.addEventListener("mousemove", w), window.addEventListener("touchmove", w), window.addEventListener("mouseup", X), window.addEventListener("touchend", X), function() {
        window.removeEventListener("mousemove", w), window.removeEventListener("touchmove", w), window.removeEventListener("mouseup", X), window.removeEventListener("touchend", X), j.cancel(O);
      };
    }
  }, [p]), i.useEffect(function() {
    W();
  }, [v]), i.useImperativeHandle(s, function() {
    return {
      delayHidden: W
    };
  });
  var H = "".concat(n, "-scrollbar"), F = {
    position: "absolute",
    visibility: ne ? null : "hidden"
  }, B = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return h ? (F.height = 8, F.left = 0, F.right = 0, F.bottom = 0, B.height = "100%", B.width = R, K ? B.left = L : B.right = L) : (F.width = 8, F.top = 0, F.bottom = 0, K ? F.right = 0 : F.left = 0, B.width = "100%", B.height = R, B.top = L), /* @__PURE__ */ i.createElement("div", {
    ref: A,
    className: _e(H, I(I(I({}, "".concat(H, "-horizontal"), h), "".concat(H, "-vertical"), !h), "".concat(H, "-visible"), ne)),
    style: N(N({}, F), g),
    onMouseDown: te,
    onMouseMove: W
  }, /* @__PURE__ */ i.createElement("div", {
    ref: J,
    className: _e("".concat(H, "-thumb"), I({}, "".concat(H, "-thumb-moving"), p)),
    style: N(N({}, B), l),
    onMouseDown: ie
  }));
});
process.env.NODE_ENV !== "production" && (Ne.displayName = "ScrollBar");
var Wt = 20;
function it() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = e / s * e;
  return isNaN(n) && (n = 0), n = Math.max(n, Wt), Math.floor(n);
}
var Bt = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], jt = [], Kt = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function At(e, s) {
  var n = e.prefixCls, f = n === void 0 ? "rc-virtual-list" : n, v = e.className, d = e.height, c = e.itemHeight, u = e.fullHeight, M = u === void 0 ? !0 : u, h = e.style, R = e.data, r = e.children, g = e.itemKey, l = e.virtual, m = e.direction, o = e.scrollWidth, p = e.component, _ = p === void 0 ? "div" : p, S = e.onScroll, E = e.onVirtualScroll, T = e.onVisibleChange, U = e.innerProps, Y = e.extraRender, x = e.styles, V = Ct(e, Bt), k = i.useCallback(function(a) {
    return typeof g == "function" ? g(a) : a == null ? void 0 : a[g];
  }, [g]), K = Ft(k, null, null), A = D(K, 4), J = A[0], Q = A[1], $ = A[2], ne = A[3], P = !!(l !== !1 && d && c), ee = i.useMemo(function() {
    return Object.values($.maps).reduce(function(a, t) {
      return a + t;
    }, 0);
  }, [$.id, $.maps]), W = P && R && (Math.max(c * R.length, ee) > d || !!o), C = m === "rtl", ue = _e(f, I({}, "".concat(f, "-rtl"), C), v), L = R || jt, te = y(), ae = y(), ie = y(), me = Ie(0), ce = D(me, 2), H = ce[0], F = ce[1], B = Ie(0), O = D(B, 2), w = O[0], X = O[1], Re = Ie(!1), le = D(Re, 2), se = le[0], pe = le[1], Me = function() {
    pe(!0);
  }, be = function() {
    pe(!1);
  }, ye = {
    getKey: k
  };
  function q(a) {
    F(function(t) {
      var b;
      typeof a == "function" ? b = a(t) : b = a;
      var z = gt(b);
      return te.current.scrollTop = z, z;
    });
  }
  var fe = y({
    start: 0,
    end: L.length
  }), Ee = y(), Le = Nt(L, k), re = D(Le, 1), st = re[0];
  Ee.current = st;
  var xe = i.useMemo(function() {
    if (!P)
      return {
        scrollHeight: void 0,
        start: 0,
        end: L.length - 1,
        offset: void 0
      };
    if (!W) {
      var a;
      return {
        scrollHeight: ((a = ae.current) === null || a === void 0 ? void 0 : a.offsetHeight) || 0,
        start: 0,
        end: L.length - 1,
        offset: void 0
      };
    }
    for (var t = 0, b, z, Z, xt = L.length, Se = 0; Se < xt; Se += 1) {
      var wt = L[Se], _t = k(wt), Je = $.get(_t), Oe = t + (Je === void 0 ? c : Je);
      Oe >= H && b === void 0 && (b = Se, z = t), Oe > H + d && Z === void 0 && (Z = Se), t = Oe;
    }
    return b === void 0 && (b = 0, z = 0, Z = Math.ceil(d / c)), Z === void 0 && (Z = L.length - 1), Z = Math.min(Z + 1, L.length - 1), {
      scrollHeight: t,
      start: b,
      end: Z,
      offset: z
    };
  }, [W, P, H, L, ne, d]), oe = xe.scrollHeight, ve = xe.start, de = xe.end, $e = xe.offset;
  fe.current.start = ve, fe.current.end = de;
  var ft = i.useState({
    width: 0,
    height: d
  }), Ye = D(ft, 2), G = Ye[0], vt = Ye[1], dt = function(t) {
    vt({
      width: t.width || t.offsetWidth,
      height: t.height || t.offsetHeight
    });
  }, Fe = y(), Xe = y(), ht = i.useMemo(function() {
    return it(G.width, o);
  }, [G.width, o]), St = i.useMemo(function() {
    return it(G.height, oe);
  }, [G.height, oe]), Te = oe - d, ze = y(Te);
  ze.current = Te;
  function gt(a) {
    var t = a;
    return Number.isNaN(ze.current) || (t = Math.min(t, ze.current)), t = Math.max(t, 0), t;
  }
  var Ve = H <= 0, We = H >= Te, Be = w <= 0, je = w >= o, mt = ct(Ve, We, Be, je), De = function() {
    return {
      x: C ? -w : w,
      y: H
    };
  }, Ce = y(De()), we = Qe(function(a) {
    if (E) {
      var t = N(N({}, De()), a);
      (Ce.current.x !== t.x || Ce.current.y !== t.y) && (E(t), Ce.current = t);
    }
  });
  function Ke(a, t) {
    var b = a;
    t ? (et.flushSync(function() {
      X(b);
    }), we()) : q(b);
  }
  function Rt(a) {
    var t = a.currentTarget.scrollTop;
    t !== H && q(t), S == null || S(a), we();
  }
  var He = function(t) {
    var b = t, z = o ? o - G.width : 0;
    return b = Math.max(b, 0), b = Math.min(b, z), b;
  }, pt = Qe(function(a, t) {
    t ? (et.flushSync(function() {
      X(function(b) {
        var z = b + (C ? -a : a);
        return He(z);
      });
    }), we()) : q(function(b) {
      var z = b + a;
      return z;
    });
  }), Mt = kt(P, Ve, We, Be, je, !!o, pt), Ae = D(Mt, 2), Pe = Ae[0], Ge = Ae[1];
  Xt(P, te, function(a, t, b) {
    return mt(a, t, b) ? !1 : (Pe({
      preventDefault: function() {
      },
      deltaX: a ? t : 0,
      deltaY: a ? 0 : t
    }), !0);
  }), ge(function() {
    function a(b) {
      P && b.preventDefault();
    }
    var t = te.current;
    return t.addEventListener("wheel", Pe), t.addEventListener("DOMMouseScroll", Ge), t.addEventListener("MozMousePixelScroll", a), function() {
      t.removeEventListener("wheel", Pe), t.removeEventListener("DOMMouseScroll", Ge), t.removeEventListener("MozMousePixelScroll", a);
    };
  }, [P]), ge(function() {
    if (o) {
      var a = He(w);
      X(a), we({
        x: a
      });
    }
  }, [G.width, o]);
  var Ue = function() {
    var t, b;
    (t = Fe.current) === null || t === void 0 || t.delayHidden(), (b = Xe.current) === null || b === void 0 || b.delayHidden();
  }, qe = Vt(te, L, $, c, k, function() {
    return Q(!0);
  }, q, Ue);
  i.useImperativeHandle(s, function() {
    return {
      nativeElement: ie.current,
      getScrollInfo: De,
      scrollTo: function(t) {
        function b(z) {
          return z && ke(z) === "object" && ("left" in z || "top" in z);
        }
        b(t) ? (t.left !== void 0 && X(He(t.left)), qe(t.top)) : qe(t);
      }
    };
  }), ge(function() {
    if (T) {
      var a = L.slice(ve, de + 1);
      T(a, L);
    }
  }, [ve, de, L]);
  var bt = $t(L, k, $, c), yt = Y == null ? void 0 : Y({
    start: ve,
    end: de,
    virtual: W,
    offsetX: w,
    offsetY: $e,
    rtl: C,
    getSize: bt
  }), Et = Ot(L, ve, de, o, w, J, r, ye), he = null;
  d && (he = N(I({}, M ? "height" : "maxHeight", d), Kt), P && (he.overflowY = "hidden", o && (he.overflowX = "hidden"), se && (he.pointerEvents = "none")));
  var Ze = {};
  return C && (Ze.dir = "rtl"), /* @__PURE__ */ i.createElement("div", lt({
    ref: ie,
    style: N(N({}, h), {}, {
      position: "relative"
    }),
    className: ue
  }, Ze, V), /* @__PURE__ */ i.createElement(ot, {
    onResize: dt
  }, /* @__PURE__ */ i.createElement(_, {
    className: "".concat(f, "-holder"),
    style: he,
    ref: te,
    onScroll: Rt,
    onMouseEnter: Ue
  }, /* @__PURE__ */ i.createElement(ut, {
    prefixCls: f,
    height: oe,
    offsetX: w,
    offsetY: $e,
    scrollWidth: o,
    onInnerResize: Q,
    ref: ae,
    innerProps: U,
    rtl: C,
    extra: yt
  }, Et))), W && oe > d && /* @__PURE__ */ i.createElement(Ne, {
    ref: Fe,
    prefixCls: f,
    scrollOffset: H,
    scrollRange: oe,
    rtl: C,
    onScroll: Ke,
    onStartMove: Me,
    onStopMove: be,
    spinSize: St,
    containerSize: G.height,
    style: x == null ? void 0 : x.verticalScrollBar,
    thumbStyle: x == null ? void 0 : x.verticalScrollBarThumb
  }), W && o > G.width && /* @__PURE__ */ i.createElement(Ne, {
    ref: Xe,
    prefixCls: f,
    scrollOffset: w,
    scrollRange: o,
    rtl: C,
    onScroll: Ke,
    onStartMove: Me,
    onStopMove: be,
    spinSize: ht,
    containerSize: G.width,
    horizontal: !0,
    style: x == null ? void 0 : x.horizontalScrollBar,
    thumbStyle: x == null ? void 0 : x.horizontalScrollBarThumb
  }));
}
var Gt = /* @__PURE__ */ i.forwardRef(At);
Gt.displayName = "List";
export {
  Gt as L
};
//# sourceMappingURL=List-Bf4pLkNs.mjs.map
